






































































































































import EmployeeSummaryView from "@/components/EmployeeSummaryView.vue";
import { apiService, AppConstants, Interfaces, Utils } from "@/core/Export";
import store from "@/store";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: { EmployeeSummaryView },
})
export default class ApprovalInfo extends Vue {
  isInSaveProcess: boolean;
  employeeKizuzTypes: Array<any>;
  amrId: number;
  approvalDto: any;

  constructor() {
    super();
    this.isInSaveProcess = false;
    this.employeeKizuzTypes = [];
    this.amrId = 0;
    this.approvalDto = {
      hasAnotherApprovalToDo: false,
      selectedKizuzType: 0,
      comments: null,
      managerComments: null,
      summary: {
        regualrHours: 0,
        overtimeHours: 0,
        sicknessDaysBalance: 0,
        vacationDaysBalance: 0,
      },
    };
  }

  created() {
    this.amrId = this.drawerParams.amrId;
    this.getAttendReportApproval();
  }

  getAttendReportApproval() {
    if (this.isManagerSign && this.isEmpSign && this.isAdditionalSign && this.isSecretarySign) return;

    this.isInSaveProcess = true;
    this.appEnv.isBusy = true;
    apiService
      .getAttendReportApproval(this.amrId, this.drawerParams.isManager)
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.approvalDto = call.callResult.data;
          this.onSetEmployeeKizuzTypes();
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.isInSaveProcess = false;
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.isInSaveProcess = false;
        this.appEnv.isBusy = false;
      });
  }

  onSaveReportApproval(toNextMonth: boolean = false) {
    this.isInSaveProcess = true;
    this.appEnv.isBusy = true;
    apiService
      .saveAttendReportApproval(this.approvalDto, this.drawerParams.isManager)
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          if (!this.drawerParams.isManager) {
            store.dispatch(AppConstants.StoreActions.ReduceApprovalsCount);
          }
          Utils.Notification.notifyPositive(this.$t("msgs.save").toString(), "thumb_up");
          if (toNextMonth) {
            this.onSetNextMonth();
            this.isInSaveProcess = false;
            this.appEnv.isBusy = false;
          } else {
            store
              .dispatch(AppConstants.StoreActions.GetEmployeeMonthAttendViewData, {
                forceCalc: true,
              })
              .finally(() => {
                this.isInSaveProcess = false;
                this.appEnv.isBusy = false;
                this.onCloseApprovalInfoDrawer();
              });
          }
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
          this.isInSaveProcess = false;
          this.appEnv.isBusy = false;
        }
      })
      .catch((err) => {
        this.isInSaveProcess = false;
        this.appEnv.isBusy = false;
      });
  }

  onSetEmployeeKizuzTypes() {
    this.employeeKizuzTypes = this.approvalDto.kizuzTypes.map((opt) => {
      return {
        value: opt.code,
        label: opt.name,
      };
    });
  }

  onSetNextMonth() {
    this.onCloseApprovalInfoDrawer();
    store.commit(
      AppConstants.StoreMutations.UpdateSelectedMonth,
      this.approvalDto.nextMonthToApproveMonth
    );
    store.commit(
      AppConstants.StoreMutations.UpdateSelectedYear,
      this.approvalDto.nextMonthToApproveYear
    );
  }

  onCloseApprovalInfoDrawer() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, false);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, null);
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {});
  }

  get kizuzTypeName() {
    return this.drawerParams.approval.empSelectedKizuzTypeName;
  }

  get signInfoMessage() {
    if (this.drawerParams.isManager) {
      return this.$t("approvlas.manager_sign_msg");
    } else {
      return this.$t("approvlas.emp_sign_msg");
    }
  }

  get isAllowViewAtSummaries() {
    if (
      this.appEnv.isAllowed(
        AppConstants.Permissions.PortalLimitViewAtSummaries
      )
    ) {
      return false;
    }
    return true;
  }

  get isReportApprovalFormVisible() {
    if (this.drawerParams.isManager) {
      if (this.drawerParams.isAdditionalApproval) return !this.isAdditionalSign;
      if (this.drawerParams.isSecretaryApproval) return !this.isSecretarySign;
      return !this.isManagerSign;
    } else {
      return !this.isEmpSign;
    }
  }

  get comments() {
    if (this.drawerParams.isAdditionalApproval) return this.approvalDto.additionalComments;
    if (this.drawerParams.isSecretaryApproval) return this.approvalDto.secreteryComments;
    return this.approvalDto.managerComments;
  }

  set comments(v) {
    if (this.drawerParams.isAdditionalApproval) this.approvalDto.additionalComments = v;
    if (this.drawerParams.isSecretaryApproval) this.approvalDto.secreteryComments = v;
    this.approvalDto.managerComments = v;
  }


  get isSecretarySign() {
    return this.drawerParams.approval.empSecretaryApprovalDate;
  }

  get isAdditionalSign() {
    return this.drawerParams.approval.empAdditionalApprovalDate;
  }

  get isManagerSign() {
    return this.drawerParams.approval.empManagerApprovalDate;
  }

  get isEmpSign() {
    return this.drawerParams.approval.empApprovalDate;
  }

  get drawerParams() {
    return store.getters.drawerParams;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
